// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1JGH1","errorLogs":"styles_errorLogs__1urLc"};